<template>
  <div>
    <nav
      class="navbar is-fixed-top has-shadow"
      role="navigation"
      aria-label="main navigation"
    >
      <div class="navbar-brand">
        <a class="navbar-item" :href="`/?lang=${activeLanguage}`">
          <img
            src="@/assets/logo_header@1x.png"
            srcset="@/assets/logo_header@2x.png 2x"
            class="is-hidden-mobile"
          />
          <img
            src="@/assets/logo_header_mobile@1x.png"
            srcset="@/assets/logo_header_mobile@2x.png 2x"
            class="is-hidden-tablet"
          />
        </a>
        <a role="button" class="navbar-burger burger" aria-label="menu" aria-expanded="false" @click="$emit('update:showMenu', !showMenu)">
          <span aria-hidden="true" class="has-background-primary"></span>
          <span aria-hidden="true" class="has-background-primary"></span>
          <span aria-hidden="true" class="has-background-primary"></span>
        </a>
      </div>
      <div class="navbar-menu" :class="{'is-active':showMenu}" id="navbar-menu">
        <div class="navbar-start">
          <div class="buttons has-addons is-hidden-tablet is-inline">
                <span
                  class="button is-uppercase i is-outlined"
                  :class="{ 'is-white': lang == activeLanguage,
                            'is-primary':lang!==activeLanguage }"
                  v-for="lang in languages"
                  :key="lang"
                  @click="$emit('changeLanguage', lang)"
                  >{{ lang }}</span
                >
              </div>
          <slot name="navbar-start-buttons" />
        </div>
        <div class="navbar-end">
          <div class="navbar-item">
            <div class="navbar-item has-dropdown is-hoverable is-hidden-mobile">
              <a
                class="navbar-link is-uppercase has-text-primary has-text-weight-bold"
                >{{ activeLanguage }}</a
              >
              <div class="navbar-dropdown">
                <a
                  class="navbar-item is-uppercase"
                  v-for="language in languages"
                  :key="language"
                  @click="$emit('changeLanguage', language)"
                  >{{ language }}</a
                >
              </div>
            </div>
            <div class="navbar-item">
              <a
                class="button is-primary"
                @click="$emit('signup')"
                v-if="!loggedIn && canSignIn"
                v-t="'NavBar.signup'"
              ></a>
              <a
                class="button is-primary"
                @click="$emit('login')"
                v-if="!loggedIn"
                v-t="'NavBar.login'"
              ></a>

              <div class="navbar-item has-dropdown is-hoverable" v-else>
                <button
                  class="button is-primary is-hidden-mobile"
                  aria-haspopup="true"
                  aria-controls="profile-menu"
                >
                  <span>{{ profile.username }}</span>
                  <span class="icon is-small">
                    <i class="fas fa-angle-down" aria-hidden="true"></i>
                  </span>
                </button>
                <div class="navbar-dropdown is-hoverable">
                  <a
                    class="navbar-item"
                    v-t="'NavBar.profile'"
                    @click="$emit('openProfile')"
                  ></a>
                  <a
                    class="navbar-item"
                    v-t="'NavBar.logout'"
                    @click="$emit('logout')"
                  ></a>
                  <router-link
                    class="navbar-item"
                    tag="a"
                    to="/dashboard"
                    v-if="isAdmin"
                    v-t="'NavBar.dashboard'"
                  ></router-link>
                </div>
              </div>
            </div>
          </div>
          <!--<div class="navbar-item is-hidden-mobile" v-if="hasMenu">
            <a @click="$emit('update:showMenu', !showMenu)" class="has-text-primary">
              <div v-if="showMenu == false">
                <span class="icon">
                  <i class="fas fa-bars fa-lg"></i>
                </span>
              </div>
              <div v-if="showMenu == true">
                <span class="icon ">
                  <i class="fas fa-times fa-lg"></i>
                </span>
              </div>
            </a>
          </div>-->
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  props: {
    languages: {
      type: Array,
      default () {
        return ['en', 'es', 'ca']
      }
    },
    activeLanguage: {
      type: String
    },
    hasMenu: {
      type: Boolean,
      default: false
    },
    canSignIn: {
      type: Boolean,
      default: false
    },
    loggedIn: {
      type: Boolean,
      default: false
    },
    isAdmin: {
      type: Boolean,
      default: false
    },
    showMenu: {
      type: Boolean,
      default: false
    },
    profile: {
      type: Object,
      default: () => {
        return {}
      }
    }
  }
}
</script>

<style scoped>
.navbar-item img {
  max-height: initial;
}
.navbar-burger span{
  height:3px;
}
</style>
